import { normalizeAndLowercaseString } from '../../utils/functionGlobais'

const urlApiDev = process.env.API_BASE_URL_DEV
const urlApiProd = process.env.API_BASE_URL
const keyDev = process.env.DEV_PRODUCT_OPEN_KEY
const keyProd = process.env.PROD_PRODUTO_OPEN_KEY

const isDev = [
  'localhost',
  'homologacao.senhadigitalplus.com.br',
  'leonardo.senhadigitalplus.com.br',
  'link.senhadigitalplus.com.br',
].includes(window.location.hostname)

const urlApi = isDev ? urlApiDev : urlApiProd
const key = isDev ? keyDev : keyProd

const headers = {
  'x-api-key': `${key}`,
  'content-type': 'application/json',
}

export const state = () => ({
  produto_open: [],
  categoria_open: [],
  categoriaRelacted: [],
})

export const getters = {
  allProducts: (state) => {
    const produtos = [...state.produto_open]
    produtos.sort((a, b) => a.valorVenda - b.valorVenda)
    return produtos
  },
  filterOneCategory: (state) => (nameCategory) => {
    return (
      state.categoria_open.find(
        (category) =>
          normalizeAndLowercaseString(category.nome) === nameCategory
      ) || []
    )
  },
  categoriaRelactedOrg: (state) => state.categoriaRelacted,
  allCategorias: (state) => {
    const categorias = [...state.categoria_open]
    const order = [
      'e-CPF',
      'e-CNPJ',
      'Nuvem',
      'e-Jurídico',
      'e-Médico',
      'e-Engenheiro',
      'e-Saúde',
    ]
    categorias.sort((a, b) => {
      const indexA = order.indexOf(a.nome)
      const indexB = order.indexOf(b.nome)

      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB
      }

      if (indexA !== -1) return -1
      if (indexB !== -1) return 1

      return a.nome.localeCompare(b.nome)
    })

    return categorias
  },
}

export const mutations = {
  SET_CATEGORIA_OPEN: (state, payload) => (state.categoria_open = payload),
  SET_PRODUTO_OPEN: (state, payload) => (state.produto_open = payload),
  SET_COOKIE_CATEGORIA: (state, payload) => {
    const updatedCategoriaRelacted = payload.map((e) => {
      const findCategory = state.categoria_open.find(
        (relacao) => relacao.nome.toLowerCase() === e.nome.toLowerCase()
      )

      return findCategory
        ? { ...findCategory, valor: e.valor }
        : { nome: e.nome, valor: e.valor }
    })

    state.categoriaRelacted = updatedCategoriaRelacted
  },
}

export const actions = {
  async fetchCategoriaOpen({ commit }) {
    const data = await this.$axios.$get(`${urlApi}/produto-open/v1/categoria`, {
      headers,
    })
    commit('SET_CATEGORIA_OPEN', data)
  },
  async fetchProdutoOpen({ commit }, { cnpj, categoria }) {
    const data = await this.$axios.$get(`${urlApi}/produto-open/v1`, {
      headers,
      params: {
        cnpj,
        categoria,
      },
    })
    commit('SET_PRODUTO_OPEN', data)
  },
  verifyCookieCategoria({ commit }) {
    const unidade = this.getters['unidade/unidadeInformation']
    const data = unidade.categoria || []
    commit('SET_COOKIE_CATEGORIA', data)
  },
}
